import {ExpertAvailabilityStatus, defaultUnavailable, Status} from '../types';

const createMenu = (awayOptions: string[]): ExpertAvailabilityStatus[] =>
    [
        {statusReason: 'available', status: Status.AVAILABLE},
        {statusReason: defaultUnavailable, status: Status.UNAVAILABLE},
    ].concat(awayOptions.map(option => ({statusReason: option, status: Status.AWAY}))) as ExpertAvailabilityStatus[];

export default createMenu;
